module.exports = __webpack_public_path__ + "media/images/static/benefit/fig_merit1-2_softbank_services-eb48d9e54c6a9247523f3a54ae45801a.png";